import { Box } from '@material-ui/core';
import classNames from 'classnames';
import { SGSForm, SGSRadioCtr } from 'components';
import { formHasField } from 'features/arretTravail/models/scenarii';
import {
    filterPeriodsOptionsByWorkedHours as filterPeriodOptionsByWorkedHours,
    filterWorkedHoursOptions,
    PeriodValuesByWorkedHours,
    WorkedHours,
    workedHoursValuesByCategorie,
    WorkStoppagePeriods,
} from 'features/arretTravail/models/StopInformation/workStoppage';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../../../../css/ArretTravail.module.scss';

interface RightsS3201SectionProps {
    store: any;
    scenario: any;
}

const RightsS3201: React.FC<RightsS3201SectionProps> = ({ store }) => {
    const { watch, setValue } = useFormContext();

    const watchWorkedHours = watch('workStoppage.rights.workedHours');
    const watchPeriod = watch('workStoppage.rights.period');
    const watchAmount = watch('workStoppage.rights.contribution');

    const hasWorkedHours = formHasField(['workStoppage.rights.workedHours'], 'formAtFields', store);
    const hasPeriod = formHasField(['workStoppage.rights.period'], 'formAtFields', store);

    const codQualification = store?.affilie?.qualification;

    const resetWorkedHours = () => {
        if (watchWorkedHours !== '') {
            setValue('workStoppage.rights.workedHours', '');
            delete store?.workStoppage?.rights?.workedHours;
        }
    };

    const resetPeriod = () => {
        if (watchPeriod !== '') {
            setValue('workStoppage.rights.period', '');
            delete store?.workStoppage?.rights?.period;
        }
    };

    const resetAmount = () => {
        setValue('workStoppage.rights.contribution', '');
        delete store?.workStoppage?.rights?.contribution;
    };

    useEffect(() => {
        /**
         * Updates salary rights based on the current eligibility case.
         * If the selected salary right is no longer valid, it resets the field.
         */
        const PeriodAvailable = PeriodValuesByWorkedHours(watchWorkedHours, codQualification);

        if (watchPeriod && watchPeriod !== '' && !PeriodAvailable.includes(watchPeriod as WorkStoppagePeriods)) {
            resetPeriod();
        }
    }, [watchWorkedHours, watchPeriod, resetPeriod]);

    useEffect(() => {
        /**
         * Updates eligibility case based on the affiliate job category.
         * If the current eligibility case is no longer valid, it resets the field.
         */
        const availableWorkedHourss = workedHoursValuesByCategorie(codQualification);
        if (!hasWorkedHours || !availableWorkedHourss.includes(watchWorkedHours as WorkedHours)) {
            resetWorkedHours();
            resetPeriod();
        }
    }, [watchWorkedHours, hasWorkedHours, setValue, store]);

    // Return null if there's no eligibility case field
    if (!hasWorkedHours) return null;

    const handleEligibilityClick = () => {
        if (watchPeriod !== '') resetPeriod();
        if (watchAmount !== '') resetAmount();
    };

    return (
        <>
            <Box className={classNames(styles.title, 'mb-4')}>Droits :</Box>
            <SGSForm.Row>
                <SGSForm.Col>
                    <Box style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
                        <SGSRadioCtr
                            row
                            options={filterWorkedHoursOptions(codQualification)}
                            name="workStoppage.rights.workedHours"
                            label="workStop.fields.workStoppage.rights.workedHours"
                            onClick={handleEligibilityClick}
                        />
                    </Box>
                </SGSForm.Col>
            </SGSForm.Row>
            {hasPeriod && (
                <SGSForm.Row>
                    <SGSForm.Col>
                        <Box style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
                            <SGSRadioCtr
                                disabled={!watchWorkedHours}
                                row
                                options={filterPeriodOptionsByWorkedHours(watchWorkedHours, codQualification)}
                                name="workStoppage.rights.period"
                                label="workStop.fields.workStoppage.rights.period"
                            />
                        </Box>
                    </SGSForm.Col>
                </SGSForm.Row>
            )}
        </>
    );
};

export default RightsS3201;
